const n = ["Contains", "NotContains"], o = (o2) => n.includes(o2);
export {
  o as isCaseSensitive
};
//# sourceMappingURL=isCaseSensitive.js.map
